import { createReducer, on } from '@ngrx/store';
import * as CallDetailsActions from '../actions/call-details.actions';

export interface CallDetailsState {
  callDetails: string | null;
  hasError: boolean;
  isFetching: boolean;
  errorCode: number | null;
  entityUrl?: string;
}

export const initialState: CallDetailsState = {
  callDetails: null,
  hasError: false,
  isFetching: false,
  errorCode: null,
  entityUrl: undefined,
};

export const callDetailsReducer = createReducer(
  initialState,
  on(CallDetailsActions.getCallDetailsRequest, (state) => ({
    ...state,
    callDetails: null,
    isFetching: true,
    hasError: false,
    errorCode: null,
    entityUrl: undefined,
  })),
  on(
    CallDetailsActions.getCallDetailsSuccess,
    (state, { csvResponse, entityUrl }) => ({
      ...state,
      callDetails: csvResponse,
      isFetching: false,
      hasError: false,
      errorCode: null,
      entityUrl,
    })
  ),
  on(CallDetailsActions.getCallDetailsFailure, (state, { errorCode }) => ({
    ...state,
    callDetails: null,
    isFetching: false,
    hasError: true,
    errorCode: Number(errorCode),
    entityUrl: undefined,
  }))
);
